  import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuseWidgetModule, FuseSidebarModule } from '@fuse/components';
import { MatTabsModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatSnackBarModule, MatDatepickerModule } from '@angular/material';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DespachoComponent } from './despacho.component';
import { DataTablesModule } from 'angular-datatables';
import { MaterialModule } from 'app/main/angular-material-elements/material.module';
import { DatoserviciosComponent } from './subdespacho/datoservicios/datoservicios.component'
import { ConsultapacienteactualComponent } from 'app/modals/consultapacienteactual/consultapacienteactual.component';
import { AgregarConsultaPacienteComponent } from '../../../modals/agregar-consulta-paciente/agregar-consulta-paciente.component';
import { PorcentajeConsultaComponent } from '../../../modals/porcentaje-consulta/porcentaje-consulta.component';
import { ServiciosactivosComponent } from './subdespacho/serviciosactivos/serviciosactivos.component';
import { socketConf } from 'environments/environment';
import { SocketIoModule } from 'ngx-socket-io';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TagEstadisticasDespachoComponent } from './subdespacho/tag-estadisticas-despacho/tag-estadisticas-despacho.component';
import { DespachoRouterModule } from './despacho.routing.module';
import { CelularDespachoComponent } from 'app/modals/celular-despacho/celular-despacho.component';
import { TotalServiciosComponent } from '../../../modals/total-servicios/total-servicios.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { GenericSearchPipe } from '../../../pipes/generic-search.pipe';
import { RellamadaComponent } from 'app/modals/rellamada/rellamada.component';
import { AgregarMedicoComponent } from 'app/modals/agregar-medico/agregar-medico.component';
import { AgregarEnfermeroComponent } from 'app/modals/agregar-enfermero/agregar-enfermero.component';
import { AgregarConductorComponent } from 'app/modals/agregar-conductor/agregar-conductor.component';
import { InfoSmsComponent } from 'app/modals/info-sms/info-sms.component';
import { EstadisticasComponent } from 'app/modals/estadisticas/estadisticas.component';
import { PrioridadPorSintomaComponent } from 'app/modals/prioridad-por-sintoma/prioridad-por-sintoma.component';
import { PqrsComponent } from 'app/modals/pqrs/pqrs.component';
import { MovilDespachoComponent } from 'app/modals/movil-despacho/movil-despacho.component';
import { EstadoTurnosComponent } from 'app/modals/estado-turnos/estado-turnos.component';
import { CelularMovilComponent } from 'app/modals/celular-movil/celular-movil.component';
import { AsignarTiempoMuertoComponent } from 'app/modals/asignar-tiempo-muerto/asignar-tiempo-muerto.component';
import { VerAgendaComponent } from 'app/components/agenda/ver-agenda/ver-agenda.component';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSidebarComponent } from '@fuse/components/sidebar/sidebar.component';
import { LoadCubeComponent } from 'app/components/load-cube/load-cube.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertModule } from 'ngx-alerts';


@NgModule({
  imports: [
    NgxPaginationModule,
    MatButtonModule,
    RouterModule,
    FuseWidgetModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    DataTablesModule,
    NgSelectModule,
    SocketIoModule.forRoot(socketConf),
    CommonModule,
    MatTabsModule,
    DespachoRouterModule,
    FuseSidebarModule,
    BrowserAnimationsModule,
    AlertModule.forRoot({maxMessages:3,timeout:3000,position:'left'})
  ],
  declarations: [
    GenericSearchPipe,
    DespachoComponent,
    LoadCubeComponent,
    TagEstadisticasDespachoComponent,
    ServiciosactivosComponent,
    RellamadaComponent,
    ConsultapacienteactualComponent,
    AgregarConsultaPacienteComponent,
    PorcentajeConsultaComponent,
    CelularDespachoComponent,
    TotalServiciosComponent,
    AgregarMedicoComponent,
    AgregarEnfermeroComponent,
    AgregarConductorComponent,
    PqrsComponent,
    PrioridadPorSintomaComponent,
    EstadisticasComponent,
    InfoSmsComponent,
    MovilDespachoComponent,
    EstadoTurnosComponent,
    CelularMovilComponent,
    AsignarTiempoMuertoComponent,
    VerAgendaComponent,

  ],
  entryComponents:[
    RellamadaComponent,
    ConsultapacienteactualComponent,
    AgregarConsultaPacienteComponent,
    PorcentajeConsultaComponent,
    CelularDespachoComponent,
    TotalServiciosComponent,
    AgregarMedicoComponent,
    AgregarEnfermeroComponent,
    AgregarConductorComponent,
    PqrsComponent,
    PrioridadPorSintomaComponent,
    EstadisticasComponent,
    InfoSmsComponent,
    MovilDespachoComponent,
    EstadoTurnosComponent,
    CelularMovilComponent,
    AsignarTiempoMuertoComponent
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "es-ES"
    }
  ],
  exports:[
    GenericSearchPipe
  ]
})
export class DespachoModule { }
